import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  wishlistItems: [],
  userWishlist:[],

};

const wishlistSlice = createSlice({
  name: "wishlist",
  initialState,
  reducers: {
    addToWishlist: (state, action) => {
      const {item , isGuest} = action.payload;
      const wishlist = isGuest ? state.wishlistItems : state.userWishlist;
      console.log("wishslice",wishlist)
    
      const itemExists = wishlist.find((wishlistItem) => wishlistItem.id === item.id);
      if(itemExists){
        return;
      }
      else {
        wishlist.push(item);
      }
    },
    removeFromWishlist: (state, action) => {
      const { productId, isGuest } = action.payload;
      console.log("object",productId)
      if (isGuest) {
        state.wishlistItems = state.wishlistItems.filter((item) => item.guid !== productId);
      } else {
        state.userWishlist = state.userWishlist.filter((item) => item.id !== productId);
      }
    },
    clearWishlist: (state,action) => {
      if (action.payload.isGuest) {
        state.wishlistItems = [];
      } else {
        state.userWishlist = [];
      }
    },
    loadUserWishlist: (state, action) => {
      state.userWishlist = action.payload;
    },
    
  },
});

export const { addToWishlist, removeFromWishlist, clearWishlist,loadUserWishlist } = wishlistSlice.actions;
export default wishlistSlice.reducer;
